"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Drawer_styled_exports = {};
__export(Drawer_styled_exports, {
  DrawerContent: () => DrawerContent,
  DrawerWrapper: () => DrawerWrapper
});
module.exports = __toCommonJS(Drawer_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var transforms = {
  top: "translateY(-100%)",
  right: "translateX(100%)",
  bottom: "translateY(100%)",
  left: "translateX(-100%)"
};
var getHeight = function getHeight2(position, height, fullHeight) {
  if (fullHeight) {
    return "100%";
  }
  return ["top", "bottom"].includes(position) && height ? height : "auto";
};
var DrawerWrapper = import_styled_components.default.div.withConfig({
  displayName: "Drawerstyled__DrawerWrapper",
  componentId: "sc-17uaml2-0"
})(function(_ref) {
  var position = _ref.position, size = _ref.size, height = _ref.height, fullHeight = _ref.fullHeight, stackOrder = _ref.stackOrder, topOffset = _ref.topOffset, open = _ref.open, backgroundColor = _ref.backgroundColor;
  return (0, import_styled_components.css)(["display:flex;background-color:", ";width:100%;height:", ";max-height:100vh;position:fixed;z-index:", ";margin-top:", "px;transform:", ";transition:transform 0.5s ease-out;", " ", " ", ""], backgroundColor, getHeight(position, height, fullHeight), stackOrder, topOffset, !open ? transforms[position] : null, position === "right" && "right: 0;", open && "box-shadow: 0 2px 6px 0 rgb(42, 81, 86, 0.2);", (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["width:", ";"], !["top", "bottom"].includes(position) && size ? size : "100%")));
});
var DrawerContent = import_styled_components.default.div.withConfig({
  displayName: "Drawerstyled__DrawerContent",
  componentId: "sc-17uaml2-1"
})(function() {
  return (0, import_styled_components.css)(["display:flex;flex-direction:column;box-sizing:border-box;width:100%;height:100%;overflow:auto;", ";"], (0, import_mixins.withStyledScrollBar)());
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DrawerContent,
  DrawerWrapper
});
//# sourceMappingURL=Drawer.styled.js.map